import React, { MouseEvent } from 'react';
import styled from '@emotion/styled';
import { Box } from '@mui/system';
import Typography from 'components/Typography/Typography';
import { theme } from 'theme';
import { ProductInfoSkeleton } from './ProductInfoSkeleton';

type ProductInfoProps = {
  isLoading: boolean;
  categoryLink: string;
  productType: string;
  productName: string;
  brandLink: string;
  brandLabel: string;
  onBrandClick: (event: MouseEvent<HTMLAnchorElement>) => void;
  onCategoryClick: (event: MouseEvent<HTMLAnchorElement>) => void;
};

export function ProductInfo({
  isLoading,
  categoryLink,
  productType,
  productName,
  brandLink,
  brandLabel,
  onCategoryClick,
  onBrandClick,
}: ProductInfoProps) {
  if (isLoading) {
    return <ProductInfoSkeleton />;
  }

  return (
    <Box display="flex" flexDirection="column">
      <ProductTypeText
        component="a"
        href={categoryLink}
        onClick={onCategoryClick}
      >
        {productType}
      </ProductTypeText>
      <MainHeadline>{productName}</MainHeadline>
      <MainSubtitle component="a" href={brandLink} onClick={onBrandClick}>
        {brandLabel}
      </MainSubtitle>
    </Box>
  );
}

///
const ProductTypeText = styled(Typography)`
  width: fit-content;
  font-size: 10px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.2px;
  text-transform: uppercase;
  color: ${theme.palette.grey.A400};
  &:hover {
    text-decoration: underline;
  }
`;

const MainHeadline = styled(Typography)`
  width: fit-content;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px;
  color: ${theme.palette.primary.main};
  padding-top: 8px;
  padding-bottom: 4px;
`;

const MainSubtitle = styled(Typography)`
  width: fit-content;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: ${theme.palette.primary.main};
  &:hover {
    text-decoration: underline;
  }
`;
